import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSatellite1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSatellite1"><Path d="M12 2H11V4H12C16.4183 4 20 7.58172 20 12V13H22V12C22 6.47715 17.5228 2 12 2Z" fill="currentColor"/><Path d="M5.09829 4.68409L4.3956 5.5052C1.0327 9.43488 1.21031 15.3525 4.92891 19.0711C8.64752 22.7897 14.5651 22.9673 18.4948 19.6044L19.3159 18.9017L12.9142 12.5L14.4142 11L13 9.58579L11.5 11.0858L5.09829 4.68409Z" fill="currentColor"/><Path d="M12 5H11V7H12C14.7614 7 17 9.23858 17 12V13H19V12C19 8.13401 15.866 5 12 5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSatellite1;
